import { animate, style, transition, trigger } from '@angular/animations'

import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  Renderer2,
  inject,
} from '@angular/core'
import { DomSanitizer, SafeStyle } from '@angular/platform-browser'
import { OverlayPosition } from '../../enums/overlay-position.enum'

@Component({
  selector: 'wm-front-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('tooltip', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(200, style({ opacity: 1 })),
      ]),
      transition(':leave', [animate(200, style({ opacity: 0 }))]),
    ]),
  ],
  imports: [],
})
export class TooltipComponent {
  /** The template to display in the tooltip */
  @Input() public template: string

  /** The positon of the overlay */
  @Input() public position: OverlayPosition

  /** The offset of the tooltip */
  @Input() public offset: number

  /** The max width of the tooltip */
  @Input() public maxWidth: number

  /** Data to be displayed directly in the tooltip if need be */
  @Input() public data?: string[]

  protected _el = inject(ElementRef)

  protected _renderer = inject(Renderer2)

  protected sanitize = inject(DomSanitizer)

  /** Whether or not the component should have the class 'top' */
  @HostBinding('class.top')
  public get top(): boolean {
    return this.position === OverlayPosition.TOP
  }

  /** Whether or not the component should have the class 'bottom' */
  @HostBinding('class.bottom')
  public get bottom(): boolean {
    return this.position === OverlayPosition.BOTTOM
  }

  /** Whether or not the component should have the class 'right' */
  @HostBinding('class.right')
  public get right(): boolean {
    return this.position === OverlayPosition.RIGHT
  }

  /** Whether or not the component should have the class 'left' */
  @HostBinding('class.left')
  public get left(): boolean {
    return this.position === OverlayPosition.LEFT
  }

  /** Whether or not the component should have the class 'left' */
  @HostBinding('style')
  public get containerMaxWidth(): SafeStyle {
    const defaultWidth = 180
    return this.sanitize.bypassSecurityTrustStyle(
      `max-width: ${this.maxWidth || defaultWidth}px`
    )
  }
}
